if (!customElements.get('quick-add-bulk')) {
  customElements.define(
    'quick-add-bulk',
    class QuickAddBulk extends BulkAdd {
      constructor() {
        super();
        
        const debouncedOnChange = debounce((event) => {
          console.log('[Nutrikorner] QuickAddBulk change event caught, new value:', event.target.value);
          if (parseInt(event.target.value) === 0) {
            this.startQueue(event.target.dataset.index, parseInt(event.target.value));
          } else {
            this.validateQuantity(event);
          }
        }, ON_CHANGE_DEBOUNCE_TIMER);

        this.addEventListener('change', debouncedOnChange.bind(this));
        
        this.lastActiveInputId = null;
        const pageParams = new URLSearchParams(window.location.search);
        window.pageNumber = decodeURIComponent(pageParams.get('page') || '');
      }

      connectedCallback() {
        if (!this.initialized) {
          this.quantity = this.querySelector('quantity-input');
          if (this.getInput()) {
            this.listenForActiveInput();
            this.listenForKeydown();
          }
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            if (
              event.source === 'quick-add' ||
              (event.cartData.items && !event.cartData.items.some((item) => item.id === parseInt(this.dataset.index))) ||
              (event.cartData.variant_id && !(event.cartData.variant_id === parseInt(this.dataset.index)))
            ) {
              return;
            }
            // If its another section that made the update
            this.onCartUpdate().then(() => {
              // Note: listenForActiveInput binds event listeners, so we shouldn't call it repeatedly
              // unless we are replacing the input element. We aren't doing that here.
            });
          });
          this.initialized = true;
        }
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
      }

      getInput() {
        return this.querySelector('quantity-input input');
      }

      selectProgressBar() {
        return this.querySelector('.progress-bar-container');
      }

      listenForActiveInput() {
        if (!this.classList.contains('hidden')) {
          this.getInput().addEventListener('focusin', (event) => event.target.select());
        }
        this.isEnterPressed = false;
      }

      listenForKeydown() {
        this.getInput().addEventListener('keydown', (event) => {
          if (event.key === 'Enter') {
            this.getInput().blur();
            this.isEnterPressed = true;
          }
        });
      }

      cleanErrorMessageOnType(event) {
        event.target.addEventListener(
          'keypress',
          () => {
            event.target.setCustomValidity('');
          },
          { once: true }
        );
      }

      onCartUpdate() {
        return new Promise((resolve) => resolve());
      }

      updateMultipleQty(items) {
        this.selectProgressBar().classList.remove('hidden');

        const ids = Object.keys(items);
        const body = JSON.stringify({
          updates: items,
          sections: this.getSectionsToRender().map((section) => section.section),
          sections_url: this.getSectionsUrl(),
        });

        const updateStartTime = performance.now();
        window.__isLocalThemeCard = true;
        const req = fetch('/cart/update.js', { ...fetchConfig(), ...{ body } });
        window.__isLocalThemeCard = false;
        
        req.then((response) => {
            console.log(`[Nutrikorner] Performance: /cart/update.js (Sections payload) took ${(performance.now() - updateStartTime).toFixed(2)}ms`);
            return response.text();
          })
          .then((state) => {
            const parsedState = JSON.parse(state);
            this.renderSections(parsedState, ids);
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'quick-add', cartData: parsedState });
            
            // Notify Shopflo to update and open drawer
            // if (typeof window.handleFloCartBtn !== 'undefined') {
            //   window.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
            //   if (window.location.pathname.includes('/products/')) {
            //     const floBtn = document.getElementById('ctm_cart-icon-bubble');
            //     if (floBtn) floBtn.click();
            //   }
            // }
          })
          .catch(() => {
            // Commented out for now and will be fixed when BE issue is done https://github.com/Shopify/shopify/issues/440605
            // e.target.setCustomValidity(error);
            // e.target.reportValidity();
            // this.resetQuantityInput(ids[index]);
            // this.selectProgressBar().classList.add('hidden');
            // e.target.select();
            // this.cleanErrorMessageOnType(e);
          })
          .finally(() => {
            this.selectProgressBar().classList.add('hidden');
            this.requestStarted = false;
          });
      }

      getSectionsToRender() {
        return [];
      }

      renderSections(parsedState, ids) {
        // ALWAYS update the global cart count and Shopflo, regardless of local UI queue!
        startCartTimer();
        // Use shared debounced updater — prevents stale count if multiple responses race.
        // /cart/add.js responses don't include item_count; fall back to /cart.js for it.
        if (typeof parsedState.item_count === 'number') {
          updateCartBubble(parsedState.item_count);
        } else {
          fetch('/cart.js', { credentials: 'same-origin' })
            .then(r => r.json())
            .then(cart => {
              console.log('[Nutrikorner] renderSections: fetched item_count from /cart.js =', cart.item_count);
              updateCartBubble(cart.item_count);
            })
            .catch(() => { });
        }



        const intersection = this.queue.filter((element) => ids.includes(element.id));
        if (intersection.length !== 0) return;
        this.getSectionsToRender().forEach((section) => {
          const sectionElement = document.getElementById(section.id);
          if (
            sectionElement &&
            sectionElement.parentElement &&
            sectionElement.parentElement.classList.contains('drawer')
          ) {
            parsedState.items.length > 0
              ? sectionElement.parentElement.classList.remove('is-empty')
              : sectionElement.parentElement.classList.add('is-empty');

            setTimeout(() => {
              if (this.cart != undefined) {
                document.querySelector('#CartDrawer-Overlay').addEventListener('click', this.cart.close.bind(this.cart));
              }
            });
          }
          const elementToReplace =
            sectionElement && sectionElement.querySelector(section.selector)
              ? sectionElement.querySelector(section.selector)
              : sectionElement;
          if (elementToReplace) {
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          }
        });

        if (this.isEnterPressed) {
          this.querySelector(`#Quantity-${this.lastActiveInputId}`).select();
        }

        this.listenForActiveInput();
        this.listenForKeydown();
      }
    }
  );
}


// function startCartTimer() {
//   let expireTime = Date.now() + 30 * 60 * 1000; // 30 minutes from now
//   sessionStorage.setItem("cartExpireTime", expireTime);
// }

// function checkCartExpiration() {
//   let expireTime = sessionStorage.getItem("cartExpireTime");
//   if (expireTime && Date.now() >= expireTime) {
//     fetch('/cart/clear.js', { method: 'POST' }) // Clears the cart
//     .then(() => {
//       sessionStorage.removeItem("cartExpireTime"); // Clear session timer
//       location.reload();
//     });
//   }
// }

// document.addEventListener("DOMContentLoaded", function () {
//   setInterval(checkCartExpiration, 60000); // Check every minute
// });